<template>
    <div>
        <compFormEdit
            class="margin-top-15 margin-right-15"
            ref="editform"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
            :col="1">
        </compFormEdit>
        <div class="text-right">
            <Button type="primary" @click="submit">确认</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { HttpCreateByPrice } from "@/service/newbigaccount";
import { HttpGetPriceTemplate } from '@/service/tasks';
import { mapState, mapGetters } from "vuex";
import mixin from '../minxin'
    export default {
        mixins: [mixin],
        data(){
            return {
                formData:{},
                tempList:[],
            }
        },
        created(){
            // 请求作业费报价模板
            HttpGetPriceTemplate({expenseCategoryType: 0, billChannel: 0}).then(res=>{
                this.workListReceive = res.data.map(item=>{
                    return {value: item.id, label: `${item.code}(${item.name})`}
                })
            });
            HttpGetPriceTemplate({expenseCategoryType: 1, billChannel: 0}).then(res=>{
                this.storageListReceive = res.data.map(item=>{
                    return {value: item.id, label: `${item.code}(${item.name})`}
                })
            });
            HttpGetPriceTemplate({expenseCategoryType: 3, billChannel: 0}).then(res=>{
                this.addedListReceive = res.data.map(item=>{
                    return {value: item.id, label: `${item.code}(${item.name})`}
                })
            });
        },
        computed:{
            ...mapGetters('dictionary', ['getBillcusorgList', 'getCusBillTypeList','getTransferHostWarehouse']),
            getBase(){
                return [
                {
                    label: "客户",
                    tag: 'vSelect',
                    key: 'organizationId',
                    options:this.getBillcusorgList,
                    span: 24,
                    labelWidth: 90,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'warehouseId',
                    options:this.getTransferHostWarehouse,
                    span: 24,
                    labelWidth: 90,
                    props:{
                        filterable:true,
                        multiple:true,
                    }
                },
                {
                    label: '结算日期',
                    tag: 'vDatepicker',
                    key: 'time',
                    span: 24,
                    labelWidth: 90,
                    props:{
                        format:'yy-mm-dd~yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: '费用类型',
                    tag: 'vSelect',
                    key: 'expenseCategoryType',
                    span: 24,
                    labelWidth: 90,
                    options: [
                        { value: 0, label: '作业费' },
                        { value: 1, label: '仓储费' },
                        { value: 3, label: '增值服务费' },
                    ],
                    props:{
                        filterable:true,
                    },
                    on:{
                        'on-change':(val)=>{
                            switch(val){
                                case 0: this.tempList = this.workListReceive; break;
                                case 1: this.tempList = this.storageListReceive; break;
                                case 3: this.tempList = this.addedListReceive; break;
                            }
                        }
                    }
                },
                {
                    label: '单据类型',
                    tag: 'vSelect',
                    key: 'orderType',
                    span: 24,
                    labelWidth: 90,
                    show:this.formData.expenseCategoryType == 0,
                    options: this.getOrderList,
                    props:{
                        filterable:true,
                        multiple:true,
                    },
                    required:false
                },
                {
                    label: '报价模板',
                    tag: 'vSelect',
                    key: 'billingPriceTemplateId',
                    span: 24,
                    labelWidth: 90,
                    options: this.tempList,
                    props:{
                        filterable:true,
                    },
                },
                ]
            }
        },
        methods:{
            async submit(){
                const valid = await this.$refs.editform.validate()
			    if (!valid) return
                
                this.formData.warehouseId = this.formData.warehouseId.join(',');
                if(this.formData.expenseCategoryType == 0){
                    this.formData.orderType = this.formData.orderType.join(',');
                }

                // 结算时间的匹配修改
                this.formData.startTime = this.formData.time.split('~')[0];
                this.formData.endTime = this.formData.time.split('~')[1];
                delete this.formData.time
                HttpCreateByPrice(this.formData).then(res=>{
                    this.$Message.success(res.message);
                    this.$emit('on-update');
                    this.cancel();
                },err=>{
                    this.$Message.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                })
            },
            cancel(){
                this.$emit('on-close')
            }
        }
    }
</script>
